import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'utils/Axios';
import { SNACKBAR_OPEN } from 'store/actions';

const drugListMembers = 'sukl,suklCodes,name,form.name,atc,atc.oldAgeOverallWeight,atc.qtIntervalDrugEffect';

const getStoredDbVersion = () => {
    if (typeof window === 'undefined') {
        return '';
    }

    try {
        const stored = window.localStorage.getItem('db-version');
        return stored ? stored.trim() : '';
    } catch (error) {
        return '';
    }
};

export const loadInfo = createAsyncThunk('interactions/loadInfo', async (_, thunkAPI) => {
    try {
        const { data } = await axios.get('/info');

        const dbVersion = typeof data?.dbVersion === 'string' ? data.dbVersion.trim() : '';
        const appVersion = typeof data?.appVersion === 'string' ? data.appVersion.trim() : '';

        return {
            dbVersion,
            appVersion
        };
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});

export const getDrugs = createAsyncThunk('interactions/getDrugs', async (arg, thunkAPI) => {
    const state = thunkAPI.getState();

    try
    {
        const previousDbVersion = getStoredDbVersion();
        const infoResult = await thunkAPI.dispatch(loadInfo()).unwrap();
        const dbVersion = infoResult.dbVersion;
        const forceUpdate = dbVersion && dbVersion > previousDbVersion;

        if(forceUpdate || state.interactions.drugs.length === 0)
        {
            const response = await axios.get(`/drugs?rql=$m=${drugListMembers}$o=name`);
            if (dbVersion) {
                localStorage.setItem('db-version', dbVersion);
            }

            response.data.forEach(drug => {

                if (drug['atc.oldAgeOverallWeight'] === undefined && drug['atc.qtIntervalDrugEffect'] === undefined) {
                    delete drug.atc;
                }
            });

            return response.data;
        }
    } catch (error) {
        if (error.status !== 401) {
            thunkAPI.dispatch({
                type: SNACKBAR_OPEN,
                open: true,
                message: 'Načítání léků selhalo je možné že aplikace nebude správně fungovat.',
                variant: 'alert',
                alertSeverity: 'error',
            });
        }
    };


    return thunkAPI.fulfillWithValue(state.interactions.drugs);
});

const initialState = {
    drugs: [],
    selectedDrugs: [],
    info: {
        dbVersion: getStoredDbVersion(),
        appVersion: '',
        status: 'idle',
        error: null
    }
}

const interactionsSlice = createSlice({
    name: 'interactions',
    initialState,
    reducers: {
        setSelectedDrugs: (state, action) => {
            if (state.selectedDrugs !== action.payload) {
                state.selectedDrugs = action.payload;
            }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getDrugs.fulfilled, (state, action) => {
          state.drugs = action.payload;
        });
        builder
            .addCase(loadInfo.pending, (state) => {
                state.info.status = 'loading';
                state.info.error = null;
            })
            .addCase(loadInfo.fulfilled, (state, action) => {
                state.info.status = 'succeeded';
                state.info.dbVersion = action.payload.dbVersion;
                state.info.appVersion = action.payload.appVersion;
            })
            .addCase(loadInfo.rejected, (state, action) => {
                state.info.status = 'failed';
                state.info.error = action.payload ?? action.error;
            });
    },
});

export const {
    setSelectedDrugs
} = interactionsSlice.actions;

export const selectInteractionsInfo = (state) => state.interactions.info;

export default interactionsSlice.reducer;
